var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-sent-message",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-sent-message:not(.animated) .animable {opacity: 0;}svg#freepik_stories-sent-message.animated #freepik--Floor--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-sent-message.animated #freepik--paper-plane--inject-2 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-sent-message.animated #freepik--Clouds--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250.47px 363.75px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.47,
    cy: 363.75,
    rx: 209.77,
    ry: 121.11,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250.47px 363.75px"
    },
    id: "eluc51filatle",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "264.03px 390.94px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.1,
    cy: 377.74,
    rx: 49.24,
    ry: 28.43,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.1px 377.74px"
    },
    id: "elaikzm9mpabf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.58,
    cy: 398.15,
    rx: 59.62,
    ry: 34.42,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "300.58px 398.15px"
    },
    id: "elxvco8wd56in",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-2",
    className: "animable",
    style: {
      transformOrigin: "186.908px 245.15px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234,366.86c0-2.5-1.64-5-4.94-6.89-6.59-3.81-17.28-3.81-23.87,0-3.3,1.9-4.95,4.4-4.95,6.89v7.71c0,2.5,1.65,5,4.95,6.9,6.59,3.8,17.28,3.8,23.87,0,3.3-1.91,4.94-4.4,4.94-6.9h0v-7.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.12px 370.716px"
    },
    id: "elp54g92f9qps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,367.68c6.59,3.81,6.59,10,0,13.79s-17.28,3.8-23.87,0-6.6-10,0-13.79S222.51,363.88,229.1,367.68Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "217.163px 374.575px"
    },
    id: "eli9blkuzn5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.28,
    y: 366.86,
    width: 33.76,
    height: 7.71,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "217.16px 370.715px"
    },
    id: "elo6czy8gy9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1,360c6.59,3.8,6.59,10,0,13.78s-17.28,3.81-23.87,0-6.6-10,0-13.78S222.51,356.16,229.1,360Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "217.163px 366.884px"
    },
    id: "el5t1lroqamxx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,361.72c3.11,1.79,3.11,4.7,0,6.49a12.43,12.43,0,0,1-11.24,0c-3.1-1.79-3.1-4.7,0-6.49A12.43,12.43,0,0,1,222.78,361.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.164px 364.965px"
    },
    id: "el36pkl9ykz2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.21,
    y: 219.41,
    width: 15.9,
    height: 145.56,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.16px 292.19px"
    },
    id: "elxiqevpi0aub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.09,152.19h0l0-.11v0c-.15-.83-.33-1.67-.54-2.51a2.68,2.68,0,0,1,.07.27c-.13-.57-.28-1.14-.44-1.71.06.21.11.42.16.63-.16-.63-.34-1.25-.53-1.88.09.27.18.55.25.82-.1-.36-.21-.72-.32-1.08l-.18-.57,0-.08v.06a61.06,61.06,0,0,0-5.28-11.71c-.07-.13-.14-.26-.22-.39h0c-5.45-9.27-13.35-17.74-22.17-23l-.43-.26a40,40,0,0,0-8-3.54,24.74,24.74,0,0,0-7.16-1.15l-.84,0-.51,0c-.42,0-.83.08-1.23.14l-.37,0-.68.13c-.29.06-.58.13-.86.21l-.78.23s0,0-.05,0l-.78.28c-.26.11-.52.22-.76.34h0l-1.72,1,0,0-86.61,50,0,0-.07,0h0c-4.69,2.63-7.53,8-7.53,15.63v47.11l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29h0l87.73-50.69V158.48A35.37,35.37,0,0,0,282.09,152.19Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "186.943px 194.63px"
    },
    id: "el2vl274jqv3y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 140.61 165.15 196.33 133.29 201.35 181.95 140.61 217.78",
    style: {
      fill: "#3CB499",
      transformOrigin: "170.98px 175.535px"
    },
    id: "el2ll5s4rfnsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrp2neigqpq8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 140.61 165.15 196.33 133.29 201.35 181.95 140.61 217.78",
    style: {
      opacity: 0.5,
      transformOrigin: "170.98px 175.535px"
    },
    className: "animable",
    id: "el1h0yx5a3et2"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 201.35 181.95 201.35 239.22 188.79 245.6 140.61 217.78",
    style: {
      fill: "#3CB499",
      transformOrigin: "170.98px 213.775px"
    },
    id: "ellfpsi201e7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsqr6fzbxvnm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "140.61 217.78 201.35 181.95 201.35 239.22 188.79 245.6 140.61 217.78",
    style: {
      opacity: 0.3,
      transformOrigin: "170.98px 213.775px"
    },
    className: "animable",
    id: "ely64otbq1okl"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,152.19l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24c-2.78-4.7-10-26.63-13.85-30.6a58,58,0,0,0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37,15.37,0,0,0-7.52,1.79l86.62-50,0,0,1.72-1h0c.24-.12.5-.23.76-.34l.78-.28s0,0,.05,0l.78-.23c.28-.08.57-.15.86-.21l.68-.13.37,0c.4-.06.81-.11,1.23-.14l.51,0,.84,0a24.74,24.74,0,0,1,7.16,1.15,40,40,0,0,1,8,3.54l.43.26C267.35,119.57,279.37,136.88,282.1,152.19Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "212.085px 154.085px"
    },
    id: "elw3lxxas2f6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,158.56l-.07,0h0Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "141.965px 158.56px"
    },
    id: "eln59g42u59b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el33x19e8oze5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "212.015px 154.085px"
    },
    className: "animable",
    id: "elt1xib4hpt1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.1,152.19l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24c-2.78-4.7-10-26.63-13.85-30.6a58,58,0,0,0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37,15.37,0,0,0-7.52,1.79l86.62-50,0,0,1.72-1h0c.24-.12.5-.23.76-.34l.78-.28s0,0,.05,0l.78-.23c.28-.08.57-.15.86-.21l.68-.13.37,0c.4-.06.81-.11,1.23-.14l.51,0,.84,0a24.74,24.74,0,0,1,7.16,1.15,40,40,0,0,1,8,3.54l.43.26C267.35,119.57,279.37,136.88,282.1,152.19Z",
    id: "el5vyocqv3col",
    className: "animable",
    style: {
      transformOrigin: "212.085px 154.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,158.56l-.07,0h0Z",
    id: "eladi0ujxcqp9",
    className: "animable",
    style: {
      transformOrigin: "141.965px 158.56px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275,134h0c.08.12.16.25.23.38C275.19,134.22,275.12,134.09,275,134Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "275.115px 134.19px"
    },
    id: "elvierp6uowid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65,143.5a48.74,48.74,0,0,1,2.45,8.69l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24h0L195,256.29l87.73-50.69V158.48A42.72,42.72,0,0,0,279.65,143.5Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "236.925px 199.895px"
    },
    id: "elc009vi471jg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35,140.36c-.37-.82-.76-1.65-1.17-2.47C277.59,138.71,278,139.54,278.35,140.36Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "277.765px 139.125px"
    },
    id: "elfyvn9qz2jik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,135c.42.76.84,1.52,1.23,2.29C276.5,136.56,276.09,135.8,275.66,135Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "276.275px 136.145px"
    },
    id: "eldb7grln7syc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,143.41c-.35-.9-.72-1.79-1.11-2.68C278.9,141.62,279.27,142.51,279.62,143.41Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "279.065px 142.07px"
    },
    id: "eltewltx1nohl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliw792seyvt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "236.925px 195.145px"
    },
    className: "animable",
    id: "elrdbe2ayp4mi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275,134h0c.08.12.16.25.23.38C275.19,134.22,275.12,134.09,275,134Z",
    id: "ely1nn3tz66aq",
    className: "animable",
    style: {
      transformOrigin: "275.115px 134.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65,143.5a48.74,48.74,0,0,1,2.45,8.69l-5.76,3.17-35.06,19.19L234.94,178l-43.82,24h0L195,256.29l87.73-50.69V158.48A42.72,42.72,0,0,0,279.65,143.5Z",
    id: "elveydoktlcwm",
    className: "animable",
    style: {
      transformOrigin: "236.925px 199.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35,140.36c-.37-.82-.76-1.65-1.17-2.47C277.59,138.71,278,139.54,278.35,140.36Z",
    id: "el0arjz15cyuhe",
    className: "animable",
    style: {
      transformOrigin: "277.765px 139.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,135c.42.76.84,1.52,1.23,2.29C276.5,136.56,276.09,135.8,275.66,135Z",
    id: "el6i1bhkqub47",
    className: "animable",
    style: {
      transformOrigin: "276.275px 136.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,143.41c-.35-.9-.72-1.79-1.11-2.68C278.9,141.62,279.27,142.51,279.62,143.41Z",
    id: "elqcmejobr2an",
    className: "animable",
    style: {
      transformOrigin: "279.065px 142.07px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,162.93c3.49,0,7.65,1.33,12,3.86,14.73,8.5,27.18,27.91,27.18,42.39V245.6l-48.18-27.82V174.23c0-9.34,4.88-11.3,9-11.3m0-6.18c-9.06,0-15.15,6.27-15.15,17.48v47.11l60.52,35V209.18c0-16.72-13.55-38.09-30.26-47.74h0c-5.5-3.17-10.67-4.69-15.11-4.69Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "164.7px 206.545px"
    },
    id: "elrkvis07xx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44,221.34l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "143.043px 252.455px"
    },
    id: "el4xeoe6s6u7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el72pvwa42bz5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.44,221.34l-32.59,18a20.81,20.81,0,0,0-.37,36.24h0a59.73,59.73,0,0,0,59.69,0L195,256.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "143.043px 252.455px"
    },
    className: "animable",
    id: "elm4ddlc17nzg"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 241.94 208.35 245.86 208.35 180.21 215.15 176.28 215.15 241.94",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "211.75px 211.07px"
    },
    id: "elbs568gfmpuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.99 181.99 208.35 193.32 208.35 180.21 227.99 168.87 227.99 181.99",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.17px 181.095px"
    },
    id: "el2gtfbbibd35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08,239.63a14.1,14.1,0,0,1-6.38,11.05c-3.53,2-6.39.39-6.39-3.68A14.09,14.09,0,0,1,211.7,236C215.22,233.91,218.08,235.56,218.08,239.63Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "211.695px 243.315px"
    },
    id: "el0yvhtx8mpufa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsda47jlb4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.08,239.63a14.1,14.1,0,0,1-6.38,11.05c-3.53,2-6.39.39-6.39-3.68A14.09,14.09,0,0,1,211.7,236C215.22,233.91,218.08,235.56,218.08,239.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "211.695px 243.315px"
    },
    className: "animable",
    id: "elom84t5hy1h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.2,240.86a14.09,14.09,0,0,1-6.38,11c-3.52,2-6.38.38-6.38-3.69a14.13,14.13,0,0,1,6.38-11.05C217.35,235.14,220.2,236.79,220.2,240.86Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "213.82px 244.499px"
    },
    id: "elz9exkxy4nq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "380.892px 326.085px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72,349,374,355.54s-5.7-18.19-2.54-36.48c1.19-6.9,3.71-10.33,4.59-12.18s7.7-13.25,1.7-18.51-20.05,5.2-19.42,33.38A109.63,109.63,0,0,0,362.72,349Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "369.252px 321.3px"
    },
    id: "el78l5b3pn2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljhqs7mew32c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72,349,374,355.54s-5.7-18.19-2.54-36.48c1.19-6.9,3.71-10.33,4.59-12.18s7.7-13.25,1.7-18.51-20.05,5.2-19.42,33.38A109.63,109.63,0,0,0,362.72,349Z",
    style: {
      opacity: 0.3,
      transformOrigin: "369.252px 321.3px"
    },
    className: "animable",
    id: "elnr1dydlnkq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368,352.54a.52.52,0,0,1-.47-.33c0-.12-4.31-12-4.09-31s10.28-29.32,10.38-29.42a.5.5,0,1,1,.71.71c-.1.1-9.86,10-10.08,28.72s4,30.51,4,30.63a.5.5,0,0,1-.3.64A.39.39,0,0,1,368,352.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "369.054px 322.091px"
    },
    id: "elywjsl3g5wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.47,354.11l18.65,11s8.54-1.26,7.9-9.3-4.12-9.94.2-13.47,5.44-3.76,5.23-7.23-2.53-5-3.63-6.34-4.15-4.25-2-8.43,5.06-8.21.74-10.12c-2.59-1.14-6.93.29-9.8,3.34s-5.26,5.26-8,6-8.41.76-8.22,5.46,1.41,6.32.27,8.4C370.68,337.29,361.51,339.41,371.47,354.11Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "385.195px 337.47px"
    },
    id: "el6amgjb26d7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.07,359.08a.5.5,0,0,1-.5-.47c0-.28-2.06-28.08,17.26-46.34a.51.51,0,1,1,.7.73c-19,17.92-17,45.26-17,45.53a.51.51,0,0,1-.46.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "387.622px 335.58px"
    },
    id: "elurzle0zh8pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.41,335.24a.5.5,0,0,1-.5-.46,15.88,15.88,0,0,0-5.67-11.1.5.5,0,1,1,.59-.81,16.58,16.58,0,0,1,6.09,11.83.5.5,0,0,1-.47.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "379.478px 329.007px"
    },
    id: "elfjo2swpjw7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,340a.48.48,0,0,1-.34-.13.5.5,0,0,1,0-.71c.2-.23,5.06-5.48,16.3-3.94a.52.52,0,0,1,.44.57.51.51,0,0,1-.57.43c-10.72-1.47-15.37,3.56-15.42,3.61A.51.51,0,0,1,381,340Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "388.958px 337.469px"
    },
    id: "elyek4vyys50d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-2",
    className: "animable",
    style: {
      transformOrigin: "101.201px 129.955px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.35,190.53c-.89,0-1.79,0-2.67-.11a.91.91,0,0,1-.84-1,.93.93,0,0,1,1-.84,26.65,26.65,0,0,0,3.57.09.94.94,0,0,1,.95.89.92.92,0,0,1-.88.95C158.09,190.53,157.72,190.53,157.35,190.53Zm4.74-.38a.92.92,0,0,1-.15-1.83,26.53,26.53,0,0,0,3.47-.81.92.92,0,0,1,.53,1.76,28.07,28.07,0,0,1-3.7.87Zm-11-.26h-.18a34.57,34.57,0,0,1-3.66-1,.94.94,0,0,1-.59-1.17.93.93,0,0,1,1.17-.58,30.71,30.71,0,0,0,3.45.92.91.91,0,0,1,.71,1.09A.92.92,0,0,1,151.11,189.89Zm18-1.91a.92.92,0,0,1-.4-1.75l.64-.31a.92.92,0,1,1,.83,1.64l-.68.34A.91.91,0,0,1,169.11,188Zm-25-.39a.92.92,0,0,1-.39-.09,34.41,34.41,0,0,1-3.33-1.78.92.92,0,1,1,1-1.57,33,33,0,0,0,3.16,1.68.93.93,0,0,1-.39,1.76Zm-6.3-3.8a1,1,0,0,1-.55-.18c-1-.74-2-1.55-2.9-2.41a.92.92,0,1,1,1.24-1.36c.9.82,1.83,1.59,2.77,2.3a.92.92,0,0,1-.56,1.65Zm-5.43-4.95a.91.91,0,0,1-.68-.3c-.83-.91-1.65-1.88-2.41-2.88a.92.92,0,0,1,1.46-1.12c.73,1,1.51,1.88,2.31,2.76a.92.92,0,0,1-.06,1.3A.93.93,0,0,1,132.41,178.84ZM127.93,173a.9.9,0,0,1-.77-.43c-.4-.62-.79-1.26-1.16-1.9-.25-.44-.5-.89-.74-1.34a.92.92,0,0,1,1.62-.86c.23.43.47.86.71,1.28.36.62.73,1.23,1.12,1.83a.93.93,0,0,1-.78,1.42Zm-3.44-6.5a.92.92,0,0,1-.85-.56c-.49-1.16-.93-2.35-1.31-3.53a.92.92,0,0,1,.59-1.16.93.93,0,0,1,1.16.6c.36,1.13.78,2.26,1.25,3.37a.91.91,0,0,1-.84,1.28Zm-2.24-7a.93.93,0,0,1-.9-.73,34.84,34.84,0,0,1-.6-3.73.92.92,0,0,1,.82-1,.86.86,0,0,1,.39,0,.89.89,0,0,1,.67-.46,22,22,0,0,0,3.44-.76.92.92,0,0,1,.55,1.76,24.68,24.68,0,0,1-3.74.83.88.88,0,0,1-.23,0c.12,1,.29,2,.5,2.94a.91.91,0,0,1-.71,1.09A.63.63,0,0,1,122.25,159.51Zm-3.17-3.82h0a28.75,28.75,0,0,1-3.79-.31.92.92,0,0,1,.27-1.82,25.21,25.21,0,0,0,3.54.29.92.92,0,0,1,0,1.84Zm-7.26-1.08a.73.73,0,0,1-.25,0A29.33,29.33,0,0,1,108,153.3a.92.92,0,0,1,.73-1.69,26.82,26.82,0,0,0,3.36,1.19.93.93,0,0,1,.63,1.14A.94.94,0,0,1,111.82,154.61Zm17.93-1.33a.92.92,0,0,1-.42-1.73,15.2,15.2,0,0,0,2.88-1.92.93.93,0,0,1,1.3.09.92.92,0,0,1-.1,1.3,16.1,16.1,0,0,1-3.23,2.16A.94.94,0,0,1,129.75,153.28Zm-8.25-1.08h0a.93.93,0,0,1-.91-.94,31.26,31.26,0,0,1,.29-3.78.92.92,0,1,1,1.82.26,29.49,29.49,0,0,0-.27,3.55A.93.93,0,0,1,121.5,152.2Zm-16.44-.47a1,1,0,0,1-.46-.12,32.07,32.07,0,0,1-3.16-2.1.9.9,0,0,1-.18-1.28.92.92,0,0,1,1.29-.19,28.3,28.3,0,0,0,3,2,.92.92,0,0,1-.46,1.72Zm30.12-3.28a.93.93,0,0,1-.46-.12.92.92,0,0,1-.33-1.26,8.72,8.72,0,0,0,.66-1.43,6,6,0,0,0,.34-1.64.91.91,0,0,1,1-.85.92.92,0,0,1,.85,1,8.24,8.24,0,0,1-.44,2.12A10.59,10.59,0,0,1,136,148,.93.93,0,0,1,135.18,148.45Zm-36-1.14a.93.93,0,0,1-.64-.26l-.61-.62c-.67-.69-1.32-1.42-1.94-2.18a.92.92,0,1,1,1.43-1.16c.58.72,1.2,1.41,1.83,2.06l.57.58a.91.91,0,0,1,0,1.3A.94.94,0,0,1,99.2,147.31Zm23.36-2.38a.84.84,0,0,1-.27,0,.92.92,0,0,1-.61-1.15,14.82,14.82,0,0,1,1.59-3.57.92.92,0,1,1,1.56,1,12.91,12.91,0,0,0-1.39,3.13A.91.91,0,0,1,122.56,144.93Zm-28-3.32a.91.91,0,0,1-.77-.42,37,37,0,0,1-1.89-3.26.92.92,0,0,1,1.64-.84,34.76,34.76,0,0,0,1.79,3.1.92.92,0,0,1-.77,1.42Zm41.17-.23a.92.92,0,0,1-.85-.57,5.33,5.33,0,0,0-1.91-2.43.92.92,0,0,1,1-1.53,7.16,7.16,0,0,1,2.58,3.26.91.91,0,0,1-.49,1.2A.92.92,0,0,1,135.73,141.38Zm-9.17-2.46a.93.93,0,0,1-.76-.4.92.92,0,0,1,.24-1.28,8.15,8.15,0,0,1,3.86-1.41.92.92,0,1,1,.16,1.83,6.26,6.26,0,0,0-3,1.11A1,1,0,0,1,126.56,138.92Zm-35.37-3.84a.92.92,0,0,1-.85-.58c-.46-1.15-.88-2.34-1.24-3.55a.92.92,0,1,1,1.76-.53c.35,1.15.75,2.3,1.19,3.4a.93.93,0,0,1-.52,1.19A.8.8,0,0,1,91.19,135.08Zm-2.13-7a.92.92,0,0,1-.9-.73c-.26-1.21-.47-2.45-.64-3.7a.92.92,0,0,1,1.82-.24c.16,1.2.37,2.39.62,3.56a.92.92,0,0,1-.71,1.09Zm-1-7.29a.93.93,0,0,1-.92-.87c0-1-.08-2-.08-3v-.77a.94.94,0,0,1,.94-.9.9.9,0,0,1,.9.93v.74c0,1,0,1.92.08,2.87a.93.93,0,0,1-.86,1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.871px 152.885px"
    },
    id: "elv1xed1dxk2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.26 87.3 91.76 111.2 31.7 98.31 97.26 87.3",
    style: {
      fill: "#3CB499",
      transformOrigin: "64.48px 99.25px"
    },
    id: "elvm9nzv0uy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el69dn203j13d"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.26 87.3 91.76 111.2 31.7 98.31 97.26 87.3",
    style: {
      opacity: 0.3,
      transformOrigin: "64.48px 99.25px"
    },
    className: "animable",
    id: "elzxsrkrpyqml"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,98.31l74.78-2,17.57,27.08Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "77.875px 109.85px"
    },
    id: "el2x2n5ortrpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.7 98.31 97.26 87.3 81.81 69.38 31.7 98.31",
    style: {
      fill: "#3CB499",
      transformOrigin: "64.48px 83.845px"
    },
    id: "ely8x1jt5p34",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "262.29px 246.485px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elufnw7mxos0o"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "172.295px 168.09px"
    },
    className: "animable",
    id: "elthtym5x9dd9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.33,168.09l-.07,0h0Z",
    id: "elw8187sdmyjc",
    className: "animable",
    style: {
      transformOrigin: "172.295px 168.09px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elmyqveha9v9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.94,
    y: 347.14,
    width: 15.83,
    height: 32.05,
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "283.855px 363.165px",
      transform: "rotate(1.46deg)"
    },
    className: "animable",
    id: "elak72f7za53f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.38,218.7s-1.11,54.52-.73,76.12c.29,16.27,2.83,65,2.83,65s10.26,6.7,21.07,1.1c0,0,6.24-49.22,4.72-64.05a25.09,25.09,0,0,1,0-5.41l9.54-82.54Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "289.69px 286.036px"
    },
    id: "elozasbppjoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,374.55s8.77-1,10.54-3.86v-1.86s1.52.81,1.23,3.89c-.26,2.86.88,7.73,1.05,13.67a3.1,3.1,0,0,1-1.2,2.52c-1.7,1.31-5.29,3.32-11.62,3.59-2.22.1-11.1,5.79-18.49,5.79s-12.22-3.66-12.22-8.78,15.07-9.75,15.07-9.75l7.24-7s-1.41-7.63,3.2-5.8S281,370.69,281,374.55Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "272.055px 382.483px"
    },
    id: "elwmq9xjxmnmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,379a.46.46,0,0,1-.44-.32c-1.54-4.61-6.35-5.46-6.4-5.47a.46.46,0,0,1-.38-.53.47.47,0,0,1,.53-.38,9.51,9.51,0,0,1,7.12,6.09.46.46,0,0,1-.29.58Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "276.013px 375.648px"
    },
    id: "el94bkc3xp99j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,381.86a.48.48,0,0,1-.44-.32c-1.53-4.59-6.35-5.46-6.4-5.47a.45.45,0,0,1-.37-.53.46.46,0,0,1,.53-.38,9.51,9.51,0,0,1,7.12,6.09.46.46,0,0,1-.3.58A.32.32,0,0,1,276.51,381.86Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "273.132px 378.507px"
    },
    id: "elm82zjoqy83d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,384.34a.45.45,0,0,1-.43-.31c-1.53-4.6-6.35-5.47-6.4-5.48a.46.46,0,1,1,.15-.9,9.48,9.48,0,0,1,7.12,6.09.46.46,0,0,1-.29.58Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "270.595px 380.985px"
    },
    id: "eliylafju45hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,389.51c0,5.06,4.73,8.69,12,8.77l10.35-4.15c0-10.73-7.26-14.37-7.26-14.37S250.33,384.4,250.33,389.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "261.505px 389.02px"
    },
    id: "elh3qzxo7v9so",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,386.83c-1.77,1.37-5.53,3.48-12.15,3.77-2.33.1-11.61,6-19.34,6-5.3,0-9.34-1.8-11.36-4.67,1.31,3.79,5.67,6.31,11.8,6.31,7.39,0,16.27-5.69,18.49-5.79,6.33-.27,9.92-2.28,11.62-3.59a3.07,3.07,0,0,0,1.18-2.3A2.5,2.5,0,0,1,293.6,386.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.295px 392.4px"
    },
    id: "elpsko8zniwv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,226.33s1.45,12.34,10.91,18.86l8.35,41.87,5.36-52.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.86px 256.695px"
    },
    id: "elfeboqrlok9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elntd3q1ge7cc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.35,
    y: 356.7,
    width: 15.83,
    height: 32.05,
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "328.265px 372.725px",
      transform: "rotate(-4.47deg)"
    },
    className: "animable",
    id: "el1m7pt2jqgc2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,220s1.91,7.23,2.83,37.06c.74,23.64,1.29,37.24,1.49,41.86a26.44,26.44,0,0,0,.37,3.43,337.21,337.21,0,0,1,3.9,36c1.35,23,1.46,33.89,1.46,33.89s-9.76,7.63-21.54,1.64l-11.4-68.54-12-63.61s-16.45-6.27-17.9-23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "307.46px 297.452px"
    },
    id: "el1rrvs03gnh2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.83,380.76l.25,3.12s-1.88,2.64-4.1,3.41c0,0-1.7-6.21-4.71-6.53s-9.26-.6-8.42,2.86a28.68,28.68,0,0,1,.87,5.51l-5.8,10.81s-11.77,10.14-6.85,16.6,21.43,3,23.06-7.14a11.26,11.26,0,0,1,4.94-7.53,6.26,6.26,0,0,0,2.81-6.47c-.3-2.32-1-6.78-.79-8.79S338.86,380.79,336.83,380.76Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "322.929px 400.199px"
    },
    id: "el5obmz4megti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,416.54c4.09,5.37,16.15,3.9,21.07-2.56a15.61,15.61,0,0,0,.32-3.19c0-11.55-14.54-10.85-14.54-10.85S303.15,410.08,308.07,416.54Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "318.164px 409.878px"
    },
    id: "ellhya96n933c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,395.4c0-.17-.05-.37-.08-.57a6.18,6.18,0,0,1-2.91,4.52,11.64,11.64,0,0,0-5.1,7.79c-1.66,10.38-18.36,14-23.66,7.59a5.8,5.8,0,0,0,.94,1.81c4.92,6.47,21.43,3,23.06-7.14a11.26,11.26,0,0,1,4.94-7.53A6.26,6.26,0,0,0,338.88,395.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.061px 407.326px"
    },
    id: "el45qntcpramn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27,391.54a.47.47,0,0,1-.32-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,1,1-.29-.87,9.47,9.47,0,0,1,9.15,2,.45.45,0,0,1,0,.65A.47.47,0,0,1,329.27,391.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "324.899px 389.931px"
    },
    id: "elafoxblhfd0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.25,395.55a.47.47,0,0,1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,0,1-.29-.88,9.52,9.52,0,0,1,9.15,2,.47.47,0,0,1,0,.65A.48.48,0,0,1,327.25,395.55Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "322.902px 393.939px"
    },
    id: "elq87cr73r35o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.24,399.56a.47.47,0,0,1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46,0,0,1-.29-.88,9.49,9.49,0,0,1,9.15,2,.47.47,0,0,1,0,.65A.49.49,0,0,1,325.24,399.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "320.892px 397.947px"
    },
    id: "elws4r1w0rz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,90.6a89,89,0,0,1-2-12.26c-.24-4.83-1.64-6.52-4.59-4.1s-9.67,9.44-9.27,14.91a34.32,34.32,0,0,0,5.59,17l8.6,2.6,3.44-7.06Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "217.006px 90.9476px"
    },
    id: "elgb4fu8umabc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.34,134.32l-17.23-3.81s-7.34-11.89-11.59-18.16-6.66-10.61-6.66-10.61l-8-2.43-4.08,6.89s13.41,33.33,19.63,39c3.13,2.82,23.35,9.08,23.35,9.08S265.25,145.32,261.34,134.32Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "238.075px 126.795px"
    },
    id: "el0beoe6xa443a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,139l-21.72-4.68a56.72,56.72,0,0,1-4.54,19.92L278.62,161Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "269.93px 147.66px"
    },
    id: "elz1ibafljl6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrnb0ilykk3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.06,139l-21.72-4.68a56.72,56.72,0,0,1-4.54,19.92L278.62,161Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "269.93px 147.66px"
    },
    className: "animable",
    id: "elif860d7koc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,141.61l10.1,3.18,5.54,29.88-3.28,14.49a16.52,16.52,0,0,0-.25,6L328.83,220s-10,6.38-28.39,6.38-29.06-7.63-29.06-7.63l1.39-56.38A36.66,36.66,0,0,1,283.06,139h0l12.53,1.45Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "300.105px 182.69px"
    },
    id: "ele9ikhn43btv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,94.18s-9.65,8.47-1.26,27.35L289.9,96Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.281px 107.855px"
    },
    id: "elu7ynzz8oimm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.19 141.61 301.03 145.52 295.59 140.45 295.59 117.66 313.19 117.66 313.19 141.61",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "304.39px 131.59px"
    },
    id: "elnkquuo1x5wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,139c5.94,0,15-5.29,15-9l2-12.37H295.59Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "304.09px 128.315px"
    },
    id: "el2t34u7amw08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,89c-5.92,0-18.51,3.3-20,18.79s.82,28.68,7.95,28.68c14,0,27.46-1.78,27.57-24.7C315.91,91.5,306.05,89,300.27,89Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "297.815px 112.735px"
    },
    id: "elagsvkx0are",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,125.3l-2.28-7a1.18,1.18,0,0,1-1.94-.89V104.91s-5.82-1.65-5.2-6.55c0,0-3,2.67-14.41,2.67S275.16,91.34,276.3,86c0,0,2.12,2.19,8.16,2.19s31.19-7.59,31.84,7.6c0,0,2.12-3.11,5.55,0l-4.41,2.62s5.23-.16,4.41,7.51c-.53,5-2.38,13.89-3.58,19.34a12.1,12.1,0,0,1-5.08,7.45h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.001px 109.355px"
    },
    id: "elvman0un8dpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.61 112.4 291.61 122.35 285.78 120.56 291.61 112.4",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "288.695px 117.375px"
    },
    id: "elbexi9ke0y8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,114a1.86,1.86,0,1,1-1.86-1.87A1.86,1.86,0,0,1,300.87,114Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.01px 113.99px"
    },
    id: "elo5lbbsyyx8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94,112.68a1.86,1.86,0,1,1-1.86-1.86A1.86,1.86,0,0,1,286.94,112.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "285.08px 112.68px"
    },
    id: "elfqppaqpz4xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,108.8l3.64-2.16s-1.4-1.45-2.79-.58S282.81,108.8,282.81,108.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.578px 107.291px"
    },
    id: "eltfgl26gcx88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,110.15,299.15,108s1.4-1.45,2.79-.58S302.8,110.15,302.8,110.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.025px 108.646px"
    },
    id: "elf7p9r7rxv3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08,127.13s2.7-1.73,5.3-3.68c0,0,1.51,2.94-.87,4.46S292.08,127.13,292.08,127.13Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "294.966px 125.94px"
    },
    id: "elme17889tx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.75 118.4 317.19 111.42 312.56 108.64 310.75 118.4",
    style: {
      fill: "rgb(37, 50, 57)",
      transformOrigin: "313.97px 113.52px"
    },
    id: "elm93y38opml8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,115.68c-2.11,3.66-1.56,8.1,1.38,9.62,1.89,1,7.47-1.13,9.58-4.79s.93-6.79-1.94-8.44S313.92,112,311.81,115.68Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "317.191px 118.482px"
    },
    id: "elpt65qkwyamm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,140.45l-2.4,3.81a6.17,6.17,0,0,0,2.51,8.84h0a11.3,11.3,0,0,0,15.53-6.21l2-5.28-8.8-3.15Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "302.733px 146.349px"
    },
    id: "elt0coxvmb1c8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86,101.74s2.94-4.48,2.89-8.73.48-6.22,1.21-7.24-.09-2.51-2.05-2c-1.66.45-3.71,3-4.16,5.35a2.56,2.56,0,0,1-1.27,1.79c-2.07,1.11-5.93,4.29-4.1,12Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "224.062px 93.2883px"
    },
    id: "elyd54odc7are",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,97.66h0a.35.35,0,0,1-.29-.4,8.93,8.93,0,0,1,4.61-6.64,2.14,2.14,0,0,0,1.1-1.54.35.35,0,0,1,.41-.27.34.34,0,0,1,.27.4,2.85,2.85,0,0,1-1.45,2,8.24,8.24,0,0,0-4.26,6.14A.34.34,0,0,1,218,97.66Z",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "220.906px 93.2336px"
    },
    id: "ele0slcbdlgw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.77 181.63 329.21 190.99 352 200.01 342.81 172.16 324.77 181.63",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "338.385px 186.085px"
    },
    id: "el19919ojkqf8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,144.37s-7.6,7.81-4.31,18.82a116.1,116.1,0,0,0,7.14,18.44s12.81.38,18-9.47l-6.53-16.48a17.88,17.88,0,0,0-12-10.67Z",
    style: {
      fill: "#3CB499",
      transformOrigin: "329.787px 163.001px"
    },
    id: "el2togxe71y0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc5pm2nbvwie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.94,144.37s-7.6,7.81-4.31,18.82a116.1,116.1,0,0,0,7.14,18.44s12.81.38,18-9.47l-6.53-16.48a17.88,17.88,0,0,0-12-10.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "329.787px 163.001px"
    },
    className: "animable",
    id: "elml0amncj35"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.93,189.25c5.76,1.69,22.74,6.72,22.74,6.72s.13.37,1.33,4c1.84,5.65-4,19.32-24.68,9.4s-28.23-15.23-28.23-15.23l2.25-12.55S321.36,187.32,327.93,189.25Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "325.705px 197.236px"
    },
    id: "eljts8pxrkh5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.54 189.54 339.25 192.63 327.26 186.84 328.54 189.54",
    style: {
      fill: "rgb(112, 56, 56)",
      transformOrigin: "333.255px 189.735px"
    },
    id: "eln7jo1ho4do",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,199.81l-13.44-1.43a2.38,2.38,0,0,1-2.06-1.76L275.3,169a1.24,1.24,0,0,1,1.26-1.56l13,.61a2.27,2.27,0,0,1,2.1,1.68l7.82,28.53A1.25,1.25,0,0,1,298.14,199.81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "287.388px 183.628px"
    },
    id: "elrr44mahb6ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,171.49a1.16,1.16,0,1,1-1.15-1.16A1.16,1.16,0,0,1,280.55,171.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.39px 171.49px"
    },
    id: "elg9hcfik63xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.34,181.63s-3.89-6.76-8.72-8.4l1.93,7.43s-3.67.29-7.82.29-8.69-2.8-10-3.52-2.53,4.3,2.69,13.76,19.71,3,19.71,3Z",
    style: {
      fill: "rgb(148, 89, 89)",
      transformOrigin: "288.467px 184.786px"
    },
    id: "elpr69h7gh2b9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "390.145px 78.2246px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.06,45.63l7.24,4.12V47.19c0-.18,0-.37,0-.54s0-.35,0-.52v-.06h0c.26-3.4,2.83-4.7,6-2.89a11.72,11.72,0,0,1,3.57,3.43c.71-4.61,4.47-6.28,9-3.65C390.91,45.87,395,53,395,58.8v5.49a2.52,2.52,0,0,0,1.24,2.15l4.25,2.49a6.15,6.15,0,0,1,3,5.3,2.54,2.54,0,0,1-3.8,2.19L360.17,53.56a6.91,6.91,0,0,1-3.45-6A2.24,2.24,0,0,1,360.06,45.63Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "380.105px 59.2331px"
    },
    id: "elsvs2a6rdneq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,91.68l5.35,3V92.83c0-.14,0-.27,0-.4s0-.26,0-.39v0h0c.19-2.51,2.09-3.47,4.41-2.13a8.55,8.55,0,0,1,2.64,2.53c.52-3.41,3.3-4.64,6.67-2.7a15,15,0,0,1,6.76,11.72v4.06a1.85,1.85,0,0,0,.91,1.59l3.15,1.84a4.55,4.55,0,0,1,2.24,3.92,1.87,1.87,0,0,1-2.8,1.62L391.52,97.54A5.1,5.1,0,0,1,389,93.12,1.65,1.65,0,0,1,391.44,91.68Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "406.285px 101.778px"
    },
    id: "el3vmfrmzaiqh",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.86798ae3d5533e2ecb05a7669ea191ac.svg";
export { ForwardRef as ReactComponent };